import { render, staticRenderFns } from "./BaseChat.vue?vue&type=template&id=087e1ad1&"
import script from "./BaseChat.vue?vue&type=script&lang=ts&"
export * from "./BaseChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports